enum Role {
    'User' = 'User',
    'Lawyer' = 'Lawyer',
    'Assistant' = 'Assistant',
    'LawfirmAdministrator' = 'LawfirmAdministrator',
    'Administrator' = 'Administrator',
}

export default Role;
